export function getBoxShadow() {
    const color = 'rgba(0, 0, 0, 0.08)';
    return {
        sm: `0 4px 8px 0 ${color}, 0 2px 4px 0 ${color}`,
        md: `0 12px 24px 0 ${color}, 0 6px 12px 0 ${color}`,
        lg: `0 24px 48px 0 ${color}, 0 12px 24px 0 ${color}`,
    };
}
